import React from "react";
import {List} from "../modules/Farms";

export function FarmsListPage() {
  return (
    <List />
  );
}
